/**
 * DPDP Compliant Multilingual Grievance Redressal Content
 * Supports English and Hindi
 */

export const grievanceRedressalContent = {
    en: {
        title: "Grievance Redressal",
        intro: "We are committed to fair, timely, and transparent grievance handling. This page explains how you can raise a grievance, how we process it, and expected resolution timelines.",
        sections: {
            1: {
                title: "1. Grievance Officer Details",
                content: [
                    "Name: {{GRIEVANCE_OFFICER_NAME}}",
                    "Title: {{GRIEVANCE_OFFICER_TITLE}}",
                    "Contact: {{GRIEVANCE_EMAIL}}"
                ]
            },
            2: {
                title: "2. How to Submit a Grievance",
                content: [
                    "Email {{GRIEVANCE_OFFICER_NAME}} at {{GRIEVANCE_EMAIL}}.",
                    "Use subject line: Grievance Redressal Request.",
                    "Include your account email, issue summary, relevant dates, and any supporting details."
                ]
            },
            3: {
                title: "3. Acknowledgement and Timelines",
                content: [
                    "We acknowledge grievance requests within 72 hours of receiving complete details.",
                    "We target resolution within 30 calendar days.",
                    "If more verification is required, we will share an interim update with revised ETA."
                ]
            },
            4: {
                title: "4. Resolution Process",
                content: [
                    "We review the grievance, validate facts, and identify corrective actions.",
                    "Where needed, we may request additional information for identity and record verification.",
                    "Final resolution is shared over email with outcome and next steps."
                ]
            },
            5: {
                title: "5. Escalation",
                content: [
                    "If you are not satisfied with the resolution, you may seek remedies available under applicable law, including escalation to the appropriate statutory authority where applicable."
                ]
            },
            6: {
                title: "6. Compliance Notes",
                content: [
                    "Grievance records are maintained only for legitimate resolution, legal, and audit purposes.",
                    "Identity verification may be required before sharing account-specific outcomes.",
                    "Any sensitive information submitted should be limited to what is necessary for resolution."
                ]
            }
        }
    },
    hi: {
        title: "शिकायत निवारण",
        intro: "हम न्यायसंगत, समय पर और पारदर्शी शिकायत निवारण के लिए प्रतिबद्ध हैं। यह पृष्ठ बताता है कि आप कैसे शिकायत दर्ज कर सकते हैं, हम इसे कैसे संसाधित करते हैं, और समाधान की अपेक्षित समय सीमा क्या है।",
        sections: {
            1: {
                title: "1. शिकायत अधिकारी का विवरण",
                content: [
                    "नाम: {{GRIEVANCE_OFFICER_NAME}}",
                    "शीर्षक: {{GRIEVANCE_OFFICER_TITLE}}",
                    "संपर्क: {{GRIEVANCE_EMAIL}}"
                ]
            },
            2: {
                title: "2. शिकायत कैसे जमा करें",
                content: [
                    "{{GRIEVANCE_OFFICER_NAME}} को {{GRIEVANCE_EMAIL}} पर ईमेल करें।",
                    "विषय पंक्ति का उपयोग करें: शिकायत निवारण अनुरोध।",
                    "अपना खाता ईमेल, समस्या का सारांश, प्रासंगिक तारीखें और कोई भी सहायक विवरण शामिल करें।"
                ]
            },
            3: {
                title: "3. स्वीकृति और समय सीमा",
                content: [
                    "हम पूर्ण विवरण प्राप्त करने के 72 घंटे के भीतर शिकायत अनुरोधों को स्वीकार करते हैं।",
                    "हम 30 कैलेंडर दिनों के भीतर समाधान का लक्ष्य रखते हैं।",
                    "यदि अधिक सत्यापन की आवश्यकता है, तो हम संशोधित ईटीए के साथ एक अंतरिम अपडेट साझा करेंगे।"
                ]
            },
            4: {
                title: "4. समाधान प्रक्रिया",
                content: [
                    "हम शिकायत की समीक्षा करते हैं, तथ्यों की पुष्टि करते हैं, और सुधारात्मक कार्रवाई की पहचान करते हैं।",
                    "जहां आवश्यक हो, हम पहचान और रिकॉर्ड सत्यापन के लिए अतिरिक्त जानकारी का अनुरोध कर सकते हैं।",
                    "अंतिम समाधान ईमेल के माध्यम से परिणाम और अगले कदमों के साथ साझा किया जाता है।"
                ]
            },
            5: {
                title: "5. एस्कलेशन",
                content: [
                    "यदि आप समाधान से संतुष्ट नहीं हैं, तो आप लागू कानून के तहत उपलब्ध उपचार मांग सकते हैं, जिसमें उपयुक्त सांविधिक प्राधिकार को एस्कलेशन शामिल है।"
                ]
            },
            6: {
                title: "6. अनुपालन नोट्स",
                content: [
                    "शिकायत रिकॉर्ड केवल वैध समाधान, कानूनी, और ऑडिट उद्देश्यों के लिए रखे जाते हैं।",
                    "खाता-विशिष्ट परिणाम साझा करने से पहले पहचान सत्यापन आवश्यक हो सकता है।",
                    "जमा किई गई कोई भी संवेदनशील जानकारी समाधान के लिए आवश्यक तक सीमित होनी चाहिए।"
                ]
            }
        }
    }
};

export function getGrievanceRedressalContent(lang = 'en') {
    return grievanceRedressalContent[lang] || grievanceRedressalContent.en;
}

export function getAvailableLanguagesForGrievance() {
    return Object.keys(grievanceRedressalContent);
}
